export default __webpack_public_path__ + "static/media/Raiders.e9a41326.jpg";